export default __webpack_public_path__ + "static/tablet_KV16-77d9a4dd1bcf91bd4f30966629ccc052.mp4";